import { render, staticRenderFns } from "./admin-dormitory-2026.vue?vue&type=template&id=03160ab6&scoped=true"
import script from "./admin-dormitory-2026.vue?vue&type=script&lang=js"
export * from "./admin-dormitory-2026.vue?vue&type=script&lang=js"
import style0 from "./admin-dormitory-2026.vue?vue&type=style&index=0&id=03160ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03160ab6",
  null
  
)

export default component.exports